import React from 'react';
import { PRIVACY_POLICY_URL } from '../Screens/PrivacyPolicy';
import {
  getPrivacyChoice,
  setPrivacyChoice,
  PRIVACY_CHOICE_RESET_EVENT,
} from '../Util/Consent';

const barStyle = {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 2147483000,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 10,
  padding: '6px 12px',
  background: '#1f1f1f',
  color: '#ffffff',
  font: '13px/1.4 Roboto, Helvetica, Arial, sans-serif',
  boxShadow: '0 -1px 4px rgba(0,0,0,0.4)',
};

const buttonStyle = {
  minWidth: 72,
  padding: '3px 12px',
  border: '1px solid #ffffff',
  borderRadius: 4,
  background: 'transparent',
  color: '#ffffff',
  font: 'inherit',
  cursor: 'pointer',
};

const linkStyle = {
  color: '#ffffff',
  textDecoration: 'underline',
};

// One-line privacy choice banner, shown until the visitor clicks Accept or
// Decline. "Cookie choices" links reset the choice and show it again.
export default function ConsentBanner() {
  const [visible, setVisible] = React.useState(() => getPrivacyChoice() === null);

  React.useEffect(() => {
    const show = () => setVisible(true);
    window.addEventListener(PRIVACY_CHOICE_RESET_EVENT, show);
    return () => window.removeEventListener(PRIVACY_CHOICE_RESET_EVENT, show);
  }, []);

  if (!visible) {
    return null;
  }

  const choose = choice => {
    setPrivacyChoice(choice);
    setVisible(false);
  };

  return (
    <div role="region" aria-label="Cookie choices" style={barStyle} data-ademero-consent-banner>
      <span>We use cookies for analytics and ads.</span>
      <button type="button" style={buttonStyle} onClick={() => choose('granted')}>
        Accept
      </button>
      <button type="button" style={buttonStyle} onClick={() => choose('denied')}>
        Decline
      </button>
      <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        Privacy
      </a>
    </div>
  );
}
